import apollo from '@/graphql'

import RemoveVideo from '@/graphql/video/RemoveVideo.gql'
import SaveVideoDetails from '@/graphql/video/SaveVideoDetails.gql'
import UploadCampaignVideo from '@/graphql/campaign/UploadCampaignVideo.gql'
import VideoDetailsQuery from '@/graphql/video/VideoDetailsQuery.gql'

import { getAcceptableDurations } from '../campaign/CampaignDetails'

// initial state
const state = {
  editableVideoFields: {},
  videoDetails: {},
}

// getters
const getters = {
  editableVideoFields: st => st.editableVideoFields,
  videoDetails: st => st.videoDetails,
}

// mutations
const mutations = {
  createVideoDetails() {
    state.editableVideoFields = {
      tmpVideo: null,
      duration: 6,
      creativeType: 'video',
    }
    state.videoDetails = {}
  },

  setEditableVideoFields(st, videoDetails) {
    state.editableVideoFields = {
      id: videoDetails.id,
      name: videoDetails.name,
    }
  },

  setTmpVideoField(st, tmpVideo) {
    state.editableVideoFields.tmpVideo = tmpVideo
  },

  setVideoDetails(st, videoDetails) {
    state.videoDetails = videoDetails
  },
}

// actions
const actions = {
  loadVideoDetails({ commit }, { id }) {
    apollo.defaultClient
      .watchQuery({
        query: VideoDetailsQuery,
        variables: { id: +id },
      })
      .subscribe(({ data: { videoDetails } }) => {
        commit('setEditableVideoFields', videoDetails)
        commit('setVideoDetails', videoDetails)
      })
  },

  removeVideo(context, { id, $message, $router }) {
    apollo.defaultClient
      .mutate({
        mutation: RemoveVideo,
        variables: { id },
      })
      .then(() => {
        $message.success('Video removed successfully.')
        $router.push('/videos')
      })
      .catch((err) => {
        $message.error(err.graphQLErrors[0].message)
      })
  },

  saveVideoDetails(context, { $message }) {
    apollo.defaultClient
      .mutate({
        mutation: SaveVideoDetails,
        variables: { fields: state.editableVideoFields },
        refetchQueries: [
          {
            query: VideoDetailsQuery,
            variables: { id: state.videoDetails.id },
          },
        ],
      })
      .then(() => {
        $message({
          message: 'Changes saved',
          type: 'success',
        })
      })
      .catch((err) => {
        $message({
          message: err,
          type: 'error',
        })
      })
  },

  async uploadVideo(context, { file, $router, fields }) {
    const hasPermission = context.getters['Auth/hasPermission']
    const acceptableDurations = getAcceptableDurations(hasPermission)
    try {
      const {
        data: {
          uploadCampaignVideo: { id },
        },
      } = await apollo.defaultClient.mutate({
        mutation: UploadCampaignVideo,
        variables: {
          fields: {
            acceptableDurations,
            companiesId: this.getters['Auth/user'].companiesId,
            duration: state.editableVideoFields.duration,
            name: file.name,
            uploadedBy: this.getters['Auth/user'].id,
            isTemplate: fields.isTemplate,
          },
          file,
        },
      })
      context.commit('setTmpVideoField', id)
      $router.push(`/video/${id}`)
    } catch (err) {
      throw err
    }
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/video/VideoDetails.js